document.addEventListener('DOMContentLoaded', () => {
  const menuToggle = document.querySelector('[data-bm-menu-toggle]');
  const mobileMenu = document.querySelector('[data-bm-mobile-menu]');

  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      const isOpen = mobileMenu.classList.toggle('is-open');
      menuToggle.setAttribute('aria-expanded', isOpen);
      document.body.classList.toggle('bm-menu-open', isOpen);
    });

    mobileMenu.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => {
        mobileMenu.classList.remove('is-open');
        menuToggle.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('bm-menu-open');
      });
    });
  }

  const header = document.querySelector('[data-bm-header]');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('is-scrolled', window.scrollY > 50);
    });
  }

  document.querySelectorAll('[data-bm-bundle-carousel]').forEach((carousel) => {
    const viewport = carousel.querySelector('.bm-bundles__viewport');
    const track = carousel.querySelector('[data-bm-bundle-track]');
    const slides = carousel.querySelectorAll('[data-bm-bundle-slide]');
    const prev = carousel.querySelector('[data-bm-bundle-prev]');
    const next = carousel.querySelector('[data-bm-bundle-next]');

    if (!viewport || !track || slides.length < 2) return;

    let index = 0;

    const goTo = (target) => {
      index = (target + slides.length) % slides.length;
      const offset = viewport.clientWidth * index;
      track.style.transform = `translateX(-${offset}px)`;
    };

    prev?.addEventListener('click', () => goTo(index - 1));
    next?.addEventListener('click', () => goTo(index + 1));
    window.addEventListener('resize', () => goTo(index));
  });

  document.querySelectorAll('[data-bm-product-gallery]').forEach((gallery) => {
    const slides = gallery.querySelectorAll('[data-bm-gallery-slide]');
    const thumbs = gallery.querySelectorAll('[data-bm-gallery-thumb]');
    const prev = gallery.querySelector('[data-bm-gallery-prev]');
    const next = gallery.querySelector('[data-bm-gallery-next]');
    if (slides.length < 2) return;

    let index = 0;

    const goTo = (target) => {
      index = (target + slides.length) % slides.length;
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
      thumbs.forEach((thumb, i) => thumb.classList.toggle('is-active', i === index));
    };

    prev?.addEventListener('click', () => goTo(index - 1));
    next?.addEventListener('click', () => goTo(index + 1));
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => goTo(Number(thumb.dataset.index)));
    });
  });

  document.querySelectorAll('[data-bm-product-form]').forEach((form) => {
    const section = form.closest('.bm-product');
    const productJson = section?.querySelector('[data-bm-product-json]');
    if (!productJson) return;

    let productData;
    try {
      productData = JSON.parse(productJson.textContent);
    } catch {
      return;
    }

    const variantSelect = form.querySelector('[data-bm-variant-id]');
    const optionSelects = form.querySelectorAll('[data-bm-variant-option]');
    const priceCompare = form.closest('.bm-product__info-col')?.querySelector('.bm-product__price-compare');
    const priceCurrent = form.closest('.bm-product__info-col')?.querySelector('.bm-product__price-current');
    const submit = form.querySelector('.bm-product__submit');

    const formatMoney = (cents) => {
      if (window.Shopify?.formatMoney) {
        return window.Shopify.formatMoney(cents);
      }
      return (cents / 100).toFixed(2) + ' €';
    };

    const updateVariant = () => {
      const selectedOptions = Array.from(optionSelects).map((select) => select.value);
      const variant = productData.variants.find((item) =>
        item.options.every((option, i) => option === selectedOptions[i])
      );

      if (!variant || !variantSelect) return;

      variantSelect.value = variant.id;

      if (priceCurrent) priceCurrent.textContent = formatMoney(variant.price);
      if (priceCompare) {
        if (variant.compare_at_price > variant.price) {
          priceCompare.textContent = formatMoney(variant.compare_at_price);
          priceCompare.style.display = '';
        } else {
          priceCompare.style.display = 'none';
        }
      }

      if (submit) {
        submit.disabled = !variant.available;
        submit.textContent = variant.available
          ? submit.dataset.availableLabel || submit.textContent
          : 'Izpārdots';
      }
    };

    if (submit && !submit.dataset.availableLabel) {
      submit.dataset.availableLabel = submit.textContent.trim();
    }

    optionSelects.forEach((select) => select.addEventListener('change', updateVariant));
  });

  document.querySelectorAll('[data-bm-related-grid]').forEach((grid) => {
    const count = Number.parseInt(grid.dataset.bmRelatedCount, 10) || 2;
    const items = Array.from(grid.querySelectorAll('[data-bm-related-item]'));
    if (items.length <= 1) return;

    for (let i = items.length - 1; i > 0; i -= 1) {
      const j = Math.floor(Math.random() * (i + 1));
      [items[i], items[j]] = [items[j], items[i]];
    }

    items.forEach((item, index) => {
      item.hidden = index >= count;
    });
  });

  const themeConfig = window.BiteMeTheme || {};
  const cartCountEl = document.querySelector('[data-bm-cart-count]');
  let cartMutationQueue = Promise.resolve();

  const formatMoney = (cents) => {
    if (window.Shopify?.formatMoney) {
      return window.Shopify.formatMoney(cents, themeConfig.moneyFormat);
    }
    return (cents / 100).toFixed(2) + ' €';
  };

  const getCartDrawer = () => document.querySelector('[data-bm-cart-drawer]');

  const updateCartCount = (count) => {
    if (cartCountEl) {
      cartCountEl.textContent = count;
    }
    const drawerCount = document.querySelector('[data-bm-cart-drawer-count]');
    if (drawerCount) {
      drawerCount.textContent = `(${count})`;
    }
    document.querySelectorAll('[data-bm-cart-page-count]').forEach((el) => {
      el.textContent = count;
    });
  };

  const updateSubtotalEls = (cents) => {
    document.querySelectorAll('[data-bm-cart-subtotal]').forEach((el) => {
      el.textContent = formatMoney(cents);
    });
  };

  const applySectionHtml = (html, rootSelector) => {
    if (!html) return;
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const next = doc.querySelector(rootSelector);
    const current = document.querySelector(rootSelector);
    if (!next || !current) return;

    const wasDrawerOpen =
      current.matches('[data-bm-cart-drawer]') && current.classList.contains('is-open');

    current.replaceWith(next);

    if (wasDrawerOpen) {
      getCartDrawer()?.classList.add('is-open');
      document.body.classList.add('bm-cart-open');
    }
  };

  const applySectionsResponse = (sections) => {
    if (!sections) return;
    applySectionHtml(sections[themeConfig.sections?.cartDrawer || 'cart-drawer'], '[data-bm-cart-drawer]');
    applySectionHtml(sections[themeConfig.sections?.cartMain || 'main'], '.bm-cart-page');
  };

  const getSectionIds = () => {
    const ids = [themeConfig.sections?.cartDrawer || 'cart-drawer'];
    if (document.querySelector('.bm-cart-page')) {
      ids.push(themeConfig.sections?.cartMain || 'main');
    }
    return ids.join(',');
  };

  const getSectionsUrl = () => {
    const root = themeConfig.rootUrl || '/';
    return root.endsWith('/') ? root : `${root}/`;
  };

  const fetchCart = () =>
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((response) => response.json());

  const refreshCartState = async () => {
    const cart = await fetchCart();
    updateCartCount(cart.item_count);
    updateSubtotalEls(cart.total_price);
    return cart;
  };

  const refreshCartSections = async () => {
    const sectionIds = getSectionIds();
    const sections = await fetch(`${getSectionsUrl()}?sections=${sectionIds}`).then((response) =>
      response.json()
    );
    applySectionsResponse(sections);
    await refreshCartState();
  };

  const syncCartFromResponse = async (cart) => {
    updateCartCount(cart.item_count);
    updateSubtotalEls(cart.total_price);

    const activeKeys = new Set(cart.items.map((item) => item.key));

    document.querySelectorAll('[data-bm-cart-item]').forEach((el) => {
      if (!activeKeys.has(el.dataset.lineKey)) {
        el.remove();
      }
    });

    cart.items.forEach((item) => {
      const el = document.querySelector(`[data-bm-cart-item][data-line-key="${CSS.escape(item.key)}"]`);
      if (!el) return;

      const qtyInput = el.querySelector('[data-bm-cart-qty-input]');
      if (qtyInput) {
        qtyInput.value = item.quantity;
      }

      el.querySelectorAll('.bm-cart-table__line-total, .bm-cart-drawer-row__line-total').forEach((node) => {
        node.textContent = formatMoney(item.final_line_price);
      });
    });

    const drawerFooter = document.querySelector('[data-bm-cart-drawer-footer]');
    if (drawerFooter) {
      drawerFooter.hidden = cart.item_count === 0;
    }

    if (cart.item_count === 0) {
      await refreshCartSections();
    }
  };

  const postCartJson = async (url, payload, { includeSections = false } = {}) => {
    const body = includeSections
      ? {
          ...payload,
          sections: getSectionIds(),
          sections_url: getSectionsUrl(),
        }
      : payload;

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(body),
    });

    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.description || data.message || 'Cart update failed');
    }
    return data;
  };

  const cartRequest = async (url, payload) => {
    const data = await postCartJson(url, payload, { includeSections: true });
    applySectionsResponse(data.sections);

    if (typeof data.item_count === 'number') {
      updateCartCount(data.item_count);
      updateSubtotalEls(data.total_price);
    } else {
      await refreshCartState();
    }
    return data;
  };

  const setCartItemUpdating = (cartItem, isUpdating) => {
    if (!cartItem) return;
    cartItem.classList.toggle('is-updating', isUpdating);
  };

  const enqueueCartMutation = (mutation) => {
    cartMutationQueue = cartMutationQueue
      .then(mutation)
      .catch((error) => {
        console.error(error);
      });
    return cartMutationQueue;
  };

  const changeCartLineQuantity = (lineKey, quantity, cartItem) =>
    enqueueCartMutation(async () => {
      setCartItemUpdating(cartItem, true);

      try {
        const cart = await postCartJson('/cart/change.js', { id: lineKey, quantity });
        await syncCartFromResponse(cart);
      } catch (error) {
        const cart = await fetchCart();
        await syncCartFromResponse(cart);
        throw error;
      } finally {
        const currentItem = document.querySelector(
          `[data-bm-cart-item][data-line-key="${CSS.escape(lineKey)}"]`
        );
        setCartItemUpdating(currentItem, false);
      }
    });

  const openCartDrawer = () => {
    const drawer = getCartDrawer();
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('bm-cart-open');
    drawer.querySelector('[data-bm-cart-panel]')?.focus();
  };

  const closeCartDrawer = () => {
    const drawer = getCartDrawer();
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('bm-cart-open');
  };

  document.querySelectorAll('[data-bm-cart-open]').forEach((trigger) => {
    trigger.addEventListener('click', () => openCartDrawer());
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-bm-cart-close]')) {
      closeCartDrawer();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeCartDrawer();
    }
  });

  document.addEventListener('click', (event) => {
    const qtyButton = event.target.closest('[data-bm-cart-qty-change]');
    const removeButton = event.target.closest('[data-bm-cart-remove]');
    if (!qtyButton && !removeButton) return;

    const cartItem = event.target.closest('[data-bm-cart-item]');
    if (!cartItem) return;

    const lineKey = cartItem.dataset.lineKey;
    const qtyInput = cartItem.querySelector('[data-bm-cart-qty-input]');
    if (!lineKey || !qtyInput) return;

    event.preventDefault();

    if (removeButton) {
      changeCartLineQuantity(lineKey, 0, cartItem);
      return;
    }

    const delta = Number.parseInt(qtyButton.dataset.bmCartQtyChange, 10);
    if (!Number.isFinite(delta)) return;

    const currentQty = Number.parseInt(qtyInput.value, 10) || 0;
    const nextQty = Math.max(0, currentQty + delta);
    if (nextQty === currentQty) return;

    qtyInput.value = nextQty;
    changeCartLineQuantity(lineKey, nextQty, cartItem);
  });

  document.addEventListener('change', (event) => {
    const input = event.target.closest('[data-bm-cart-qty-input]');
    if (!input) return;

    const cartItem = input.closest('[data-bm-cart-item]');
    if (!cartItem) return;

    const lineKey = cartItem.dataset.lineKey;
    if (!lineKey) return;

    const quantity = Math.max(0, Number.parseInt(input.value, 10) || 0);
    changeCartLineQuantity(lineKey, quantity, cartItem);
  });

  const addProductToCart = (variantId, quantity) =>
    enqueueCartMutation(async () => {
      await postCartJson('/cart/add.js', {
        id: variantId,
        quantity,
      });
      await refreshCartSections();
      openCartDrawer();
    });

  document.addEventListener('click', async (event) => {
    const cardAddButton = event.target.closest('[data-bm-card-add]');
    if (!cardAddButton || cardAddButton.disabled) return;

    event.preventDefault();

    const variantId = Number.parseInt(cardAddButton.dataset.variantId, 10);
    if (!variantId) return;

    cardAddButton.disabled = true;

    try {
      await addProductToCart(variantId, 1);
    } catch (error) {
      console.error(error);
      window.location.assign(themeConfig.cartUrl || '/cart');
    } finally {
      cardAddButton.disabled = false;
    }
  });

  document.querySelectorAll('[data-bm-product-form]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      const variantField = form.querySelector('[name="id"]');
      const quantityField = form.querySelector('[name="quantity"]');
      if (!variantField?.value) return;

      const submit = form.querySelector('.bm-product__submit');
      if (submit) {
        submit.disabled = true;
      }

      try {
        await addProductToCart(
          Number.parseInt(variantField.value, 10),
          Number.parseInt(quantityField?.value || '1', 10) || 1
        );
      } catch (error) {
        console.error(error);
        window.location.assign(themeConfig.cartUrl || '/cart');
      } finally {
        if (submit) {
          submit.disabled = false;
        }
      }
    });
  });
});
